import React from "react";

export default function Hero({
  title = "Default Title",
  subtitle = "",
  backgroundImage,
  variant = "inner", // 👈 NEW
  overlayOpacity = "bg-black/50",
  children,
}) {
  const heightClass =
    variant === "home"
      ? "min-h-[30vh] xs:min-h-[30vh] sm:min-h-[35vh] md:min-h-[55vh] lg:min-h-[70vh]"
      : "min-h-[220px] sm:min-h-[280px]";

  return (
    <section
      className={`relative w-full flex items-center justify-center text-center text-white ${heightClass}`}
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className={`absolute inset-0 ${overlayOpacity}`} />

      <div className="relative z-10 max-w-3xl px-4 sm:px-6">
        <h1 className="text-2xl sm:text-3xl md:text-5xl font-bold mb-3 leading-tight px-2">
          {title}
        </h1>

        {subtitle && (
          <p className="text-sm sm:text-base md:text-xl text-gray-200 px-4">
            {subtitle}
          </p>
        )}

        {children && <div className="mt-5">{children}</div>}
      </div>
    </section>
  );
}